import React from 'react';
import { NavigationItem } from '@mds/app-layout';
import { Box, Stack, Typography } from '@mui/material';

export interface SideBarMenuItemProps {
    _id?: string;
    name: string;
    selected?: boolean;
    url?: string;
}

const SidebarNavigation = ({
    id,
    menuItems,
    onChange,
}: {
    id?: string;
    menuItems: Array<SideBarMenuItemProps>;
    onChange: (menu: SideBarMenuItemProps) => void;
}): JSX.Element => {
    return (
        <Box
            id={id}
            component="nav"
            aria-label="Publisher navigation"
            sx={{
                width: '100%',
                minHeight: '100%',
                borderRight: 1,
                borderColor: 'divider',
                bgcolor: 'background.default',
                px: 1,
                py: 2,
            }}
        >
            <Typography
                variant="label2"
                sx={{
                    color: 'text.secondary',
                    px: 1.5,
                }}
            >
                Manage Insights content
            </Typography>
            <Stack
                spacing={0.5}
                sx={{
                    pt: 1,
                }}
            >
                {menuItems.map((menuItem) => (
                    <NavigationItem
                        key={menuItem._id ?? menuItem.url ?? menuItem.name}
                        to={menuItem.url}
                        orientation="vertical"
                        active={menuItem.selected}
                        onClick={(): void => onChange(menuItem)}
                    >
                        <Typography variant="body2">{menuItem.name}</Typography>
                    </NavigationItem>
                ))}
            </Stack>
        </Box>
    );
};

export default SidebarNavigation;
